import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FcAssistant } from "react-icons/fc";
export default class Permision extends Component {
    render() {
        return (
            <div className="d-flex align-items-center justify-content-center vh-100">
                <div className="text-center">
                    <h1 className="display-1 fw-bold"><FcAssistant /></h1>
                    <p className="fs-3"> <span className="text-danger">Opps!</span> Permission Denied</p>
                    <p className="lead">
                        You do not have the necessary permissions to access this resource.<br />Please check your access rights or contact your system administrator for assistance.
                    </p>
                </div>
            </div>
        )
    }
}
